import { api } from 'api'
import { getDemoData, matchRestRequest } from '../utils'
import { CompanyInfo } from 'api/company/companyInfo'

export const mockGetCompanyInfo = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/current_company_e542fced',
      'POST'
    ),
  getResponse: async () => {
    const realCompanyInfo = await getCompanyInfo()
    const demoData = getDemoData()

    return {
      data: {
        company: {
          ...realCompanyInfo,
          hasVndlyIntegration: false,
          takePercentageEstimate:
            demoData.companyOverrides?.takePercentageEstimate ??
            realCompanyInfo?.takePercentageEstimate,
          bonusTakePercentageEstimate:
            demoData.companyOverrides?.bonusTakePercentageEstimate ??
            realCompanyInfo?.bonusTakePercentageEstimate,
        },
      },
    }
  },
}

async function getCompanyInfo() {
  const response = await api.post<CompanyInfo>(
    '/company/graphql_dispatch/current_company_7a77e0eb',
    {}
  )
  const company = response.data

  if (!company) {
    return null
  }

  return {
    ...company,
    id: Number(company.id),
    takePercentageEstimate: company.takePercentageEstimate,
    bonusTakePercentageEstimate: company.bonusTakePercentageEstimate,
  }
}
